import { ArrowRight as o } from "./index537.js";
import { buildProps as e, definePropType as r } from "./index601.js";
import { iconPropType as t } from "./index606.js";
const l = e({
  /**
   * @description title of the panel
   */
  title: {
    type: String,
    default: ""
  },
  /**
   * @description unique identification of the panel
   */
  name: {
    type: r([String, Number]),
    default: void 0
  },
  /**
   * @description icon of the collapse item
   */
  icon: {
    type: t,
    default: o
  },
  /**
   * @description disable the collapse item
   */
  disabled: Boolean
});
export {
  l as collapseItemProps
};
